{
  "public-appointment-details-page": {
    "buttons": {
      "book-new-appointment": "Đặt lịch hẹn mới",
      "cancel": "Hủy lịch hẹn"
    }
  }
}
